import { Stack, Typography } from '@mui/material';
import React from 'react';
import logo from 'src/assets/images/logo.png';

export class AuthHeader extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      text: props.text || 'Let\'s organize better, together.'
    };
  }

  render() {
    return (
      <Stack direction="column" spacing={2} sx={{ mb: 2, justifyContent: 'center', alignItems: 'center' }}>
            <img src={logo} alt="logo" width={'120px'} height={'auto'} style={{ verticalAlign: 'middle' }} />
            <Typography variant="p" style={{color: '#a7a7a7ff', textAlign: 'center', marginTop: 0}}>
                {this.state.text}
            </Typography>
        </Stack>
    );
  }
}
